
<main>
    <div class="profile-details">
        <div class="profile-form">
            <form [formGroup]="GalleryAddForm" (ngSubmit)="GalleryFolderAdd()">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="ફોલ્ડર નામ"
                        formControlName="folder_name" />
                    <div *ngIf="submitted && f.folder_name.errors" class="error-message">
                        <small *ngIf="f.folder_name.errors?.required" class="text-danger">ફોલ્ડર નું નામ
                            જરૂરી
                            છે.</small>
                    </div>
                </div>

                <div class="form-group">
                    <input type="file" class="form-control" placeholder="image_src"
                        formControlName="image_src" />
                    <div *ngIf="submitted && f.image_src.errors" class="error-message">
                        <small *ngIf="f.image_src.errors?.required" class="text-danger">image_src નામ
                            જરૂરી
                            છે.</small>
                    </div>
                </div>
                
                <div class="form-group">
                    <button type="submit" class="btn-common">નોંધણી કરો</button>
                </div>
            </form>
        </div>
    </div>
</main>